import { Controller } from "@hotwired/stimulus"

// Shows a cookie banner once, until the visitor accepts or declines analytics and
// advertising cookies (one choice governs both - see meta_pixel.js and the layout's
// Consent Mode default). The choice is stored only in localStorage (no cookie, no server
// record), like the newsletter pop-up.
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.stored()) return
    this.element.hidden = false
  }

  accept() {
    this.decide("granted")
  }

  decline() {
    this.decide("denied")
  }

  decide(value) {
    this.remember(value)
    this.updateConsent(value)
    document.dispatchEvent(new CustomEvent("spicy:consent-changed", { detail: { value } }))
    this.element.hidden = true
  }

  stored() {
    try {
      return window.localStorage.getItem(this.keyValue)
    } catch (error) {
      return null
    }
  }

  remember(value) {
    try {
      window.localStorage.setItem(this.keyValue, value)
    } catch (error) {
      // Storage can be blocked: the banner may show again, which is harmless.
    }
  }

  updateConsent(value) {
    if (typeof window.gtag !== "function") return
    window.gtag("consent", "update", {
      analytics_storage: value,
      ad_storage: value,
      ad_user_data: value,
      ad_personalization: value
    })
  }
}
